import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService, AuthenticationService, UserService } from '../_services/index';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { FacebookService, InitParams, LoginResponse, LoginOptions, AuthResponse } from 'ng2-facebook-sdk';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
declare let $: any
import { environment } from '../../environments/environment';
import { Helper } from '../_helpers/index';
import { TranslateService } from '@ngx-translate/core';
import { PaymentServices } from '../_services/payment.services';



@Component({
  selector: 'app-wizard',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.css']
})
export class WizardComponent implements OnInit {
  model: any = {}
  pagedetails: any
  selectedVal
  wizardForm: FormGroup;
  loading = false;
  backendUrl: any;
  currency: any;
  timezone: any;
  id: any;
  view_error: any;
  error: any;
  lang_value: any = {};
  timezoneArr: any;
  countryCodeArr: any;
  currencyCode: any;
  calling_code: any;
  rest_data: any;
  rest_id: any;
  country:any;
  billingRole:any;
  countryIds:any;
  partnerId:any;
  apicount:any=0;


  constructor(fo: FormBuilder, private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private alertService: AlertService,
    private userService: UserService,
    private paymentServic:PaymentServices,
    private http: Http, private helper: Helper, private translate: TranslateService) {
    this.backendUrl = environment.url;
   
    this.id = environment.appid;
    this.translate.get(['valid_required', 'wz_alphan_char', 'wz_page_sub', 'wz_register_success', 'wz_login_again', 'wz_current_step', 'wz_pagination', 'wz_finish', 'wz_next', 'wz_previous', 'wz_loading','rest_already_exist']).subscribe(res => {
      this.lang_value = res;
    });

    
  }


  ngOnInit() { 
    console.log("baaaaaaaaaaaaaaaaaaaaaaaaaaa",this.backendUrl);
    let whiteLabelSetting = JSON.parse(localStorage.getItem('whiteLabelSetting'));
    this.partnerId=whiteLabelSetting.partner_id;
    var getPartner=whiteLabelSetting.partner_id;
    console.log("dddddddddddddddddddddddd",this.partnerId,getPartner)

    //d9e20344-0afc-4aa9-adce-615f4ebc6181;
  


    var self = this;
    this.paymentServic.getBillingRole().subscribe(response=>{
      this.billingRole = response.role_id
    })

    this.translate.get(['valid_required', 'wz_alphan_char', 'wz_page_sub', 'wz_register_success', 'wz_login_again', 'wz_current_step', 'wz_pagination', 'wz_finish', 'wz_next', 'wz_previous', 'wz_loading', 'valid_requied','rest_already_exist']).subscribe(res => {
      this.lang_value = res;

      $(function() {
        var settings = {
          labels: {
            current: self.lang_value.wz_current_step ? self.lang_value.wz_current_step : 'current step',
            pagination: self.lang_value.wz_pagination ? self.lang_value.wz_pagination : 'Pagination',
            finish: self.lang_value.wz_finish ? self.lang_value.wz_finish : 'Finish',
            next: self.lang_value.wz_next ? self.lang_value.wz_next : 'Next',
            previous: self.lang_value.wz_previous ? self.lang_value.wz_previous : 'Previous',
            loading: self.lang_value.wz_loading ? self.lang_value.wz_loading : 'Loading...'
          }
        };
    
        $.validator.addMethod("lettersonly", function(value, element) {
          return this.optional(element) || !$.isNumeric(value);
        }, self.lang_value.wz_alphan_char);

        $.validator.addMethod("clsRequired", function(value, element) {
          return value == '';
        }, "This field is required");

        $("#wizard").steps(settings);
        $("#form").steps({
          bodyTag: "fieldset",
          labels: {
            current: self.lang_value.wz_current_step ? self.lang_value.wz_current_step : 'current step',
            pagination: self.lang_value.wz_pagination ? self.lang_value.wz_pagination : 'Pagination',
            finish: self.lang_value.wz_finish ? self.lang_value.wz_finish : 'Finish',
            next: self.lang_value.wz_next ? self.lang_value.wz_next : 'Next',
            previous: self.lang_value.wz_previous ? self.lang_value.wz_previous : 'Previous',
            loading: self.lang_value.wz_loading ? self.lang_value.wz_loading : 'Loading...'
          },
          onStepChanging: function(event, currentIndex, newIndex) {
            // Always allow going backward even if the current step contains invalid fields!
            if (currentIndex > newIndex) {
              return true;
            }

            // Forbid suppressing "Warning" step if the user is to young
            if (newIndex === 3) {
              return false;
            }

            var form = $(this);

            // Clean up if user went backward before
            if (currentIndex < newIndex) {
              console.log(newIndex);
              console.log(form);
              // To remove error styles
              $(".body:eq(" + newIndex + ") label.error", form).remove();
              $(".body:eq(" + newIndex + ") .error", form).removeClass("error");
            }

            // Disable validation on fields that are disabled or hidden.
            form.validate().settings.ignore = ":disabled,:hidden";

            // Start validation; Prevent going forward if false
            return form.valid();
          },
          onStepChanged: function(event, currentIndex, priorIndex) {
            // Suppress (skip) "Warning" step if the user is old enough.
            if (currentIndex === 2) {
              $(this).steps("next");
            }

            // Suppress (skip) "Warning" step if the user is old enough and wants to the previous step.
            if (currentIndex === 2 && priorIndex === 3) {
              $(this).steps("previous");
            }
          },
          onFinishing: function(event, currentIndex) {
            var form = $(this);
            console.log($("#chat_lang-error"));
            $("#chat_lang-error").removeClass('hide');
            // $('#restname-error').addClass('hide');
            // $("#chat_lang").addClass('error');
            console.log(form);
            // Disable validation on fields that are disabled.
            // At this point it's recommended to do an overall check (mean ignoring only disabled fields)
            form.validate().settings.ignore = ":disabled";

            // Start validation; Prevent form submission if false
            return form.valid();
          },
          onFinished: function(event, currentIndex) {
            var form = $(this);
            console.log(form);
            var datastring = form.serializeArray();
            var o = {};

            $.each(datastring, function() {
              console.log(datastring);
              if (o[this.name]) {
                if (!o[this.name].push) {
                  o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
              } else {
                o[this.name] = this.value || '';
              }
            });
            //form.submit();
            $(document).on("click", ".actions ul li a", function() {
              console.log("actions");
              console.log($(this));
              if ($(this).attr('href') === '#finish' &&  self.apicount== 0) {
                self.apicount = 1;
                $(this).append('<i class="fa fa-spinner fa-spin fa-1x fa-fw" id="itag"></i>');
                self.resDetails(o);  
              }
          
            })

     

          }
        })

        $(document).ready(function() {
          // $(document).on('click', '#dropdownopen', () => {
          //   self.dropdownopennew();
          // })
          // $(document).on('change', '#restname', (e) => {
          //   console.log("change");
          //   self.restnamenew(e);
          // })

          $(document).on('change', '#chat_lang', () => {
            console.log('change in chatbot');
            $("#chat_lang-error").removeClass('hide');
            $("#chat_lang").removeClass('clsRequired');
            $("#chat_lang").removeClass('error');
          })
          // $('#form').validate({
          //   errorPlacement: function(error, element) {
          //     console.log('click element');
          //     $("#chat_lang-error").removeClass('hide');
          //     $("#chat_lang").addClass('error');
          //     // $('#restname-error').addClass('hide');
          //     element.after(error);
          //   },
          //   rules: {
          //     restaurant: {
          //       required: true,
          //       lettersonly: true
          //     },
          //     // page: {
          //     //   required: true
          //     // },
          //     branch: {
          //       required: true
          //     },
          //     time_zone: { required: true },
          //     chat_lang: { required: true },
          //     currency: { required: true },
          //     country: { required: true }
          //   },
          //   messages: {
          //     restaurant: {
          //       required: self.lang_value.valid_required
          //     },
          //     // page: {
          //     //   required: self.lang_value.valid_required
          //     // },
          //     branch: {
          //       required: self.lang_value.valid_required
          //     },
          //     chat_lang: { required: self.lang_value.valid_required },
          //     time_zone: { required: self.lang_value.valid_required },
          //     currency: { required: self.lang_value.valid_required }
          //   }
          // });

              $('#form').validate({
                errorPlacement: function(error, element) {
                  console.log('click element');
                  $("#chat_lang-error").removeClass('hide');
                  $("#chat_lang").addClass('error');
                  // $('#restname-error').addClass('hide');
                  element.after(error);
                },
                rules: {
                  restaurant: {
                    required: true,
                    lettersonly: true
                  },
                  // page: {
                  //   required: true
                  // },
                  branch: {
                    required: true
                  },
                  time_zone: { required: true },
                  chat_lang: { required: true },
                  currency: { required: true },
                  country: { required: true }
                },
                messages: {
                  restaurant: {
                    required: self.lang_value.valid_required
                  },
                  // page: {
                  //   required: self.lang_value.valid_required
                  // },
                  branch: {
                    required: self.lang_value.valid_required
                  },
                  chat_lang: { required: self.lang_value.valid_required },
                  time_zone: { required: self.lang_value.valid_required },
                  currency: { required: self.lang_value.valid_required }
                }
              });
        });




        $('#country').on('change', function() {
          let val = $('#country').val();
          console.log("value--", val);

          let selected_timezone = self.timezoneArr.filter((element, index) => {
            return element.country.toLowerCase() == val.toLowerCase();
          })
          let selected_curreny = self.currencyCode.filter((element, index) => {
            return element.country.toLowerCase() == val.toLowerCase();
          })
          console.log("selected_timezone", selected_timezone, selected_curreny);

          if (selected_curreny.length > 0) {
            console.log("currency_code", selected_curreny[0].currency_code);
            $('#currency').val(selected_curreny[0].currency_code)
          }
          console.log("selected_timezone", selected_timezone, selected_curreny);
          if (selected_timezone.length > 0) {
            $('#time_zone').empty();
            let str = '';
            for (var i = 0; i < selected_timezone.length; ++i) {
              console.log("selected_timezone", selected_timezone[i].id, selected_timezone[i].timezone);
              str += '<option value="' + selected_timezone[i].id + '">' + selected_timezone[i].timezone + '</option>'
            }
            $('#time_zone').append(str);
          }

        })

      });


    });

    let currentUser = JSON.parse(localStorage.getItem('pagedetails'));
    let list: string[] = [];
    //console.log(currentUser);
    if (currentUser) {
      currentUser.data.forEach(element => {
        list.push(element);
        //list.push(element.name);
      });
      this.pagedetails = list;
      console.log(this.pagedetails)
    }

    this.countryCodeArr = [{ "code": "+7 840", "name": "Abkhazia" }, { "code": "+93", "name": "Afghanistan" }, { "code": "+355", "name": "Albania" }, { "code": "+213", "name": "Algeria" }, { "code": "+1 684", "name": "American Samoa" }, { "code": "+376", "name": "Andorra" }, { "code": "+244", "name": "Angola" }, { "code": "+1 264", "name": "Anguilla" }, { "code": "+1 268", "name": "Antigua and Barbuda" }, { "code": "+54", "name": "Argentina" }, { "code": "+374", "name": "Armenia" }, { "code": "+297", "name": "Aruba" }, { "code": "+247", "name": "Ascension" }, { "code": "+61", "name": "Australia" }, { "code": "+672", "name": "Australian External Territories" }, { "code": "+43", "name": "Austria" }, { "code": "+994", "name": "Azerbaijan" }, { "code": "+1 242", "name": "Bahamas" }, { "code": "+973", "name": "Bahrain" }, { "code": "+880", "name": "Bangladesh" }, { "code": "+1 246", "name": "Barbados" }, { "code": "+1 268", "name": "Barbuda" }, { "code": "+375", "name": "Belarus" }, { "code": "+32", "name": "Belgium" }, { "code": "+501", "name": "Belize" }, { "code": "+229", "name": "Benin" }, { "code": "+1 441", "name": "Bermuda" }, { "code": "+975", "name": "Bhutan" }, { "code": "+591", "name": "Bolivia" }, { "code": "+387", "name": "Bosnia and Herzegovina" }, { "code": "+267", "name": "Botswana" }, { "code": "+55", "name": "Brazil" }, { "code": "+246", "name": "British Indian Ocean Territory" }, { "code": "+1 284", "name": "British Virgin Islands" }, { "code": "+673", "name": "Brunei" }, { "code": "+359", "name": "Bulgaria" }, { "code": "+226", "name": "Burkina Faso" }, { "code": "+257", "name": "Burundi" }, { "code": "+855", "name": "Cambodia" }, { "code": "+237", "name": "Cameroon" }, { "code": "+1", "name": "Canada" }, { "code": "+238", "name": "Cape Verde" }, { "code": "+ 345", "name": "Cayman Islands" }, { "code": "+236", "name": "Central African Republic" }, { "code": "+235", "name": "Chad" }, { "code": "+56", "name": "Chile" }, { "code": "+86", "name": "China" }, { "code": "+61", "name": "Christmas Island" }, { "code": "+61", "name": "Cocos-Keeling Islands" }, { "code": "+57", "name": "Colombia" }, { "code": "+269", "name": "Comoros" }, { "code": "+242", "name": "Congo" }, { "code": "+243", "name": "Congo, Dem. Rep. of (Zaire)" }, { "code": "+682", "name": "Cook Islands" }, { "code": "+506", "name": "Costa Rica" }, { "code": "+385", "name": "Croatia" }, { "code": "+53", "name": "Cuba" }, { "code": "+599", "name": "Curacao" }, { "code": "+537", "name": "Cyprus" }, { "code": "+420", "name": "Czech Republic" }, { "code": "+45", "name": "Denmark" }, { "code": "+246", "name": "Diego Garcia" }, { "code": "+253", "name": "Djibouti" }, { "code": "+1 767", "name": "Dominica" }, { "code": "+1 809", "name": "Dominican Republic" }, { "code": "+670", "name": "East Timor" }, { "code": "+56", "name": "Easter Island" }, { "code": "+593", "name": "Ecuador" }, { "code": "+20", "name": "Egypt" }, { "code": "+503", "name": "El Salvador" }, { "code": "+240", "name": "Equatorial Guinea" }, { "code": "+291", "name": "Eritrea" }, { "code": "+372", "name": "Estonia" }, { "code": "+251", "name": "Ethiopia" }, { "code": "+500", "name": "Falkland Islands" }, { "code": "+298", "name": "Faroe Islands" }, { "code": "+679", "name": "Fiji" }, { "code": "+358", "name": "Finland" }, { "code": "+33", "name": "France" }, { "code": "+596", "name": "French Antilles" }, { "code": "+594", "name": "French Guiana" }, { "code": "+689", "name": "French Polynesia" }, { "code": "+241", "name": "Gabon" }, { "code": "+220", "name": "Gambia" }, { "code": "+995", "name": "Georgia" }, { "code": "+49", "name": "Germany" }, { "code": "+233", "name": "Ghana" }, { "code": "+350", "name": "Gibraltar" }, { "code": "+30", "name": "Greece" }, { "code": "+299", "name": "Greenland" }, { "code": "+1 473", "name": "Grenada" }, { "code": "+590", "name": "Guadeloupe" }, { "code": "+1 671", "name": "Guam" }, { "code": "+502", "name": "Guatemala" }, { "code": "+224", "name": "Guinea" }, { "code": "+245", "name": "Guinea-Bissau" }, { "code": "+595", "name": "Guyana" }, { "code": "+509", "name": "Haiti" }, { "code": "+504", "name": "Honduras" }, { "code": "+852", "name": "Hong Kong" }, { "code": "+36", "name": "Hungary" }, { "code": "+354", "name": "Iceland" }, { "code": "+91", "name": "India" }, { "code": "+62", "name": "Indonesia" }, { "code": "+98", "name": "Iran" }, { "code": "+964", "name": "Iraq" }, { "code": "+353", "name": "Ireland" }, { "code": "+972", "name": "Israel" }, { "code": "+39", "name": "Italy" }, { "code": "+225", "name": "Ivory Coast" }, { "code": "+1 876", "name": "Jamaica" }, { "code": "+81", "name": "Japan" }, { "code": "+962", "name": "Jordan" }, { "code": "+7 7", "name": "Kazakhstan" }, { "code": "+254", "name": "Kenya" }, { "code": "+686", "name": "Kiribati" }, { "code": "+965", "name": "Kuwait" }, { "code": "+996", "name": "Kyrgyzstan" }, { "code": "+856", "name": "Laos" }, { "code": "+371", "name": "Latvia" }, { "code": "+961", "name": "Lebanon" }, { "code": "+266", "name": "Lesotho" }, { "code": "+231", "name": "Liberia" }, { "code": "+218", "name": "Libya" }, { "code": "+423", "name": "Liechtenstein" }, { "code": "+370", "name": "Lithuania" }, { "code": "+352", "name": "Luxembourg" }, { "code": "+853", "name": "Macau SAR China" }, { "code": "+389", "name": "Macedonia" }, { "code": "+261", "name": "Madagascar" }, { "code": "+265", "name": "Malawi" }, { "code": "+60", "name": "Malaysia" }, { "code": "+960", "name": "Maldives" }, { "code": "+223", "name": "Mali" }, { "code": "+356", "name": "Malta" }, { "code": "+692", "name": "Marshall Islands" }, { "code": "+596", "name": "Martinique" }, { "code": "+222", "name": "Mauritania" }, { "code": "+230", "name": "Mauritius" }, { "code": "+262", "name": "Mayotte" }, { "code": "+52", "name": "Mexico" }, { "code": "+691", "name": "Micronesia" }, { "code": "+1 808", "name": "Midway Island" }, { "code": "+373", "name": "Moldova" }, { "code": "+377", "name": "Monaco" }, { "code": "+976", "name": "Mongolia" }, { "code": "+382", "name": "Montenegro" }, { "code": "+1664", "name": "Montserrat" }, { "code": "+212", "name": "Morocco" }, { "code": "+95", "name": "Myanmar" }, { "code": "+264", "name": "Namibia" }, { "code": "+674", "name": "Nauru" }, { "code": "+977", "name": "Nepal" }, { "code": "+31", "name": "Netherlands" }, { "code": "+599", "name": "Netherlands Antilles" }, { "code": "+1 869", "name": "Nevis" }, { "code": "+687", "name": "New Caledonia" }, { "code": "+64", "name": "New Zealand" }, { "code": "+505", "name": "Nicaragua" }, { "code": "+227", "name": "Niger" }, { "code": "+234", "name": "Nigeria" }, { "code": "+683", "name": "Niue" }, { "code": "+672", "name": "Norfolk Island" }, { "code": "+850", "name": "North Korea" }, { "code": "+1 670", "name": "Northern Mariana Islands" }, { "code": "+47", "name": "Norway" }, { "code": "+968", "name": "Oman" }, { "code": "+92", "name": "Pakistan" }, { "code": "+680", "name": "Palau" }, { "code": "+970", "name": "Palestinian Territory" }, { "code": "+507", "name": "Panama" }, { "code": "+675", "name": "Papua New Guinea" }, { "code": "+595", "name": "Paraguay" }, { "code": "+51", "name": "Peru" }, { "code": "+63", "name": "Philippines" }, { "code": "+48", "name": "Poland" }, { "code": "+351", "name": "Portugal" }, { "code": "+1 787", "name": "Puerto Rico" }, { "code": "+974", "name": "Qatar" }, { "code": "+262", "name": "Reunion" }, { "code": "+40", "name": "Romania" }, { "code": "+7", "name": "Russia" }, { "code": "+250", "name": "Rwanda" }, { "code": "+685", "name": "Samoa" }, { "code": "+378", "name": "San Marino" }, { "code": "+966", "name": "Saudi Arabia" }, { "code": "+221", "name": "Senegal" }, { "code": "+381", "name": "Serbia" }, { "code": "+248", "name": "Seychelles" }, { "code": "+232", "name": "Sierra Leone" }, { "code": "+65", "name": "Singapore" }, { "code": "+421", "name": "Slovakia" }, { "code": "+386", "name": "Slovenia" }, { "code": "+677", "name": "Solomon Islands" }, { "code": "+27", "name": "South Africa" }, { "code": "+500", "name": "South Georgia and the South Sandwich Islands" }, { "code": "+82", "name": "South Korea" }, { "code": "+34", "name": "Spain" }, { "code": "+94", "name": "Sri Lanka" }, { "code": "+249", "name": "Sudan" }, { "code": "+597", "name": "Suriname" }, { "code": "+268", "name": "Swaziland" }, { "code": "+46", "name": "Sweden" }, { "code": "+41", "name": "Switzerland" }, { "code": "+963", "name": "Syria" }, { "code": "+886", "name": "Taiwan" }, { "code": "+992", "name": "Tajikistan" }, { "code": "+255", "name": "Tanzania" }, { "code": "+66", "name": "Thailand" }, { "code": "+670", "name": "Timor Leste" }, { "code": "+228", "name": "Togo" }, { "code": "+690", "name": "Tokelau" }, { "code": "+676", "name": "Tonga" }, { "code": "+1 868", "name": "Trinidad and Tobago" }, { "code": "+216", "name": "Tunisia" }, { "code": "+90", "name": "Turkey" }, { "code": "+993", "name": "Turkmenistan" }, { "code": "+1 649", "name": "Turks and Caicos Islands" }, { "code": "+688", "name": "Tuvalu" }, { "code": "+1 340", "name": "U.S. Virgin Islands" }, { "code": "+256", "name": "Uganda" }, { "code": "+380", "name": "Ukraine" }, { "code": "+971", "name": "United Arab Emirates" }, { "code": "+44", "name": "United Kingdom" }, { "code": "+1", "name": "United States" }, { "code": "+598", "name": "Uruguay" }, { "code": "+998", "name": "Uzbekistan" }, { "code": "+678", "name": "Vanuatu" }, { "code": "+58", "name": "Venezuela" }, { "code": "+84", "name": "Vietnam" }, { "code": "+1 808", "name": "Wake Island" }, { "code": "+681", "name": "Wallis and Futuna" }, { "code": "+967", "name": "Yemen" }, { "code": "+260", "name": "Zambia" }, { "code": "+255", "name": "Zanzibar" }, { "code": "+263", "name": "Zimbabwe" }];

    $.getJSON('https://ipapi.co/json/', function(data, textStatus, jqXHR) {
      if (data) {
        console.log("data", data);
        let country = data.country_name;
        let timezone = data.timezone;
        let currency = data.currency;
        let language_value = data.languages.split(',')[0].split('-')[0];
        self.calling_code = data.country_calling_code;
        country = country.trim().toLowerCase();
        console.log(language_value);
        setTimeout(function() {
          $("#chat_lang option").each(function(){
            console.log($(this).val())
            if($(this).val() == language_value){
              $(this).prop('selected', true);
            }
          })
          $('#country').val(country);
          $('#currency').val(currency);
          $("#time_zone option").each(function() {
            if ($(this).text() == timezone) {
              $(this).prop('selected', true);
            }
          });
        }, 3000);
      }
    });

    this.userService.getTimezoneCountrycode(this.backendUrl)
      .subscribe(data => {
        this.timezoneArr = data['timezone'];
        this.currencyCode = data['currencycode'];
        this.countryIds=data['country_ids']
      })
    let currentRest = JSON.parse(localStorage.getItem('currentUser'));
    let user_id = currentRest.user_id;

    let dropdowndata = {
      user_id: user_id
    }

    this.userService.adddropdownonwizard(this.backendUrl, JSON.stringify(dropdowndata))
      .subscribe(data => {
        this.rest_data = data;
        console.log("adddropdownonwizard", data);
      });
  }

  /*countryChange(val){
   console.log("val",val);
     let selected_timezone=this.timezoneArr.filter( (element,index) => {
                               return   element.country.toLowerCase() == val.toLowerCase();     
                           })
      
     let selected_curreny=this.currencyCode.filter( (element,index) =>{
                               return   element.country.toLowerCase() == val.toLowerCase();     
              }) 
  }*/

  // dropdownopennew() {
  //   $("#restname").html('');
  //   if ($('#dropdownopen').prop("checked") == true) {
  //     $("#restname").removeClass('hide');
  //     $("#labelshow").removeClass('hide');
  //     $("#chat_lang").prop('disabled',true);    
  //     $('#chat_lang').addClass('hide');
  //     $('#chat_lang-error').addClass('hide');
  //     $('#chat').addClass('hide');
  //     $('#restname').prop('disabled',false);
  //     $('#restname').addClass('clsRequired');
  //     $('#restname').removeClass('error');
  //     $('#restname-error').removeClass('hide');
  //     let mydata = '<option>Select</option>';
  //   for (var i = 0; i < this.rest_data.length; i++) {

  //     mydata += '<option _ngcontent-c0 value="' + this.rest_data[i].restaurant_id + '">' + this.rest_data[i].restaurant_name + '</option>';
  //   }
  //   var value = $("#restname").append(mydata);
  //   } else { 
  //    // $("#chat_lang").addClass('clsRequired'); 
  //    $("#chat_lang").removeClass('error');
  //     $("#chat_lang").prop('disabled',false);
  //     $("#chat_lang").removeClass('hide');
  //     $("#chat").removeClass('hide');      
  //     $("#restname").attr('disabled','disabled'); 
  //     $("#restname").addClass('hide');
  //     $("#labelshow").addClass('hide');  
  //     $('#restname-error').addClass('hide');
  //     $('#chat_lang-error').removeClass('hide');
  //     $('#chat_lang').removeClass('clsRequired');  
  //   }    
  // }

  // restnamenew(e) {
  //   $("#chat_lang-error").addClass('hide');
  //   $("#chat_lang").removeClass('clsRequired');
  //   $("#chat_lang").removeClass('error');
  //   $("#restname-error").addClass('hide');
  //   $("#restname-error").css('display','block');
  //   $("#restname").removeClass('clsRequired');
  //   $("#restname").removeClass('error');

  //   let rt_id = e.target.value;
  //   this.rest_id = rt_id;
  // if(rt_id == 'Select'){
  //   $("#restname-error").removeClass('hide');
  //   $("#restname-error").css('display','none');
  //   $("#restname").addClass('clsRequired');
  //   $("#restname").addClass('error');
  // }    
  //   let currentRest = JSON.parse(localStorage.getItem('currentUser'));
  //   let user_id = currentRest.user_id;
  //   let pickdata = {
  //     restaurant_id: rt_id,
  //     user_id: user_id
  //   }
  //   console.log(pickdata);
  //   this.userService.pickdropdownwizard(this.backendUrl, JSON.stringify(pickdata))
  //     .subscribe(data => {
  //       console.log("pickdropdownwizard", data);
  //     });
  // }

  resDetails(value: any) {
    console.log(value);
    let res_name = value.restaurant;
    let page_id = value.page;
    let branch = 0;
    let chat_lang = value.chat_lang;
    let timezone = $('#time_zone option:selected').text();
    let currency = value.currency;
    let country = value.country;
    this.country = country;
    console.log(currency + '==' + timezone);
    let pagedet =(this.pagedetails && this.pagedetails.length>0)?this.pagedetails.filter(x => x.id === page_id):[];
    console.log(pagedet);
    let access_token =(pagedet.length>0)?pagedet[0].access_token:'NA';
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    console.log(currentUser)
    let user_id = currentUser.user_id;
    let u_fname = currentUser.first_name;
    let date = new Date();
    let date_time = this.helper.getDateTimeInClientTz(date, '');
    let itag = $('#itag').show();
    let partner_id="";
    let restaurant_setting:any={}
    let whitelabelSetting=JSON.parse(localStorage.getItem('whiteLabelSetting'))
    if(whitelabelSetting && whitelabelSetting.dashboard){
    partner_id=whitelabelSetting.partner_id
    if(whitelabelSetting.ecom && whitelabelSetting.ecom.settings && whitelabelSetting.ecom.settings.common_settings){
      restaurant_setting=whitelabelSetting.ecom.settings.common_settings;
      // restaurant_setting.css_settings=whitelabelSetting.ecom.settings.css_settings;
    }
    if(whitelabelSetting.ecom && whitelabelSetting.ecom.settings && whitelabelSetting.ecom.settings.ecom_display_deliverypartner){
      restaurant_setting.ecom_display_deliverypartner=whitelabelSetting.ecom.settings.ecom_display_deliverypartner
    }
    
    }
    console.log(itag);
    let sel_code = this.countryCodeArr.filter(element => {
      return element.name.toLowerCase() == country
    })
    let calling_code = '';
    if (sel_code.length > 0) {
      calling_code = sel_code[0].code;
    }

    console.log("country", country, calling_code);
    let payload={};
    let payload2={};
    let payload3={};
    if(page_id){
      localStorage.setItem('domainPageId', JSON.stringify({'page_id': page_id,'isPageExist':true}));
      payload={ 'page_id': page_id,'isPageExist':true };
      payload2={ 'page_id': page_id, 'access_token': access_token,'isPageExist':true };
      payload3={ 'isPageExist':true };
    }else{
      localStorage.setItem('domainPageId', JSON.stringify({'page_id': "NA",'isPageExist':false}));
      payload={ 'page_id': page_id,'isPageExist':false };
      payload2={ 'page_id': page_id, 'access_token': access_token,'isPageExist':false };
      payload3={ 'isPageExist':false };
    }
    this.userService.getRestDetailsByPageID(this.backendUrl, JSON.stringify(payload))
      .subscribe(data => {
        console.log(data.data);
        if (data && data.data &&data.data.length && !data.pass) {
          if ((data.err != undefined) && data.err.length > 0) {
            this.view_error = data;
            this.error = data.err;
            $('#fail').show();
          } else {
            $('#error').html(this.lang_value.wz_page_sub);
            $('#error').show();
            setTimeout(function() {
              $('#error').hide();
            }, 3000);
            $('#itag').hide();
          }
          //this.alertService.error('Page is already subscribed'); 
        } else {
          this.userService.subscribedApps(this.backendUrl, JSON.stringify(payload2))
            .subscribe(data_new => {
                if ((data.err != undefined) && data.err.length > 0) {
                  console.log(data_new);
                  this.view_error = data;
                  this.error = data.err;
                  $('#fail').show();
                } else {
                  console.log("data is===:", JSON.stringify(data_new));
                  let headers = new Headers({ 'Content-Type': 'application/json' });
                  let options = new RequestOptions({ headers: headers, method: "post" });
                  // whitelist domian
                  this.userService.fbWebviewSettings(this.backendUrl, JSON.stringify({"partner_id":partner_id}))
                    .subscribe(data => {
                      console.log(data);
                      if (data.length) {
                        if(page_id){
                          var url = 'https://graph.facebook.com/v8.0/me/messenger_profile?access_token=' + access_token;
                          fetch(url, {
                              method: 'post',
                              headers: {
                                'Accept': 'application/json, text/plain, /',
                                'Content-Type': 'application/json'
                              },
                              body: data[0].whitelist_add
                            }).then(res => res.json())
                            .then(res => {
                              console.log(res);
                              // if ($('#dropdownopen').prop("checked") == true) {
                              //   console.log("enter in true");
                              //   let json_data = {
                              //     restaurant_id: this.rest_id,
                              //     restaurant_name: res_name,
                              //     created_at: date_time,
                              //     updated_at: date_time,
                              //     user_id: user_id,
                              //     page_id: page_id,
                              //     page_token: access_token,
                              //     single_branch: branch,
                              //     status: 0,
                              //     subscribed_status: 1,
                              //     bot_language: chat_lang,
                              //     webview_wl_status: 1,
                              //     time_zone: timezone,
                              //     currency: currency,
                              //     country: country,
                              //     calling_code: calling_code
                              //   };
                              //   console.log(json_data);
                              //   this.userService.saveWizardData(this.backendUrl, JSON.stringify(json_data))
                              //     .subscribe(data => {
                              //         console.log(data);
                              //         let restaurant_id = data.id;
                              //         if (restaurant_id) {
                              //           let mailData = {
                              //             'first_name': currentUser.first_name,
                              //             'last_name': currentUser.last_name,
                              //             'email': currentUser.email,
                              //             'stage': 'Restaurant_added'
                              //           };
                              //           this.userService.send_mail(this.backendUrl, JSON.stringify({ 'data': mailData }))
                              //             .subscribe(data => {
                              //                 console.log(data);
                              //               },
                              //               error => {
                              //                 this.alertService.error(JSON.stringify(error));
                              //               });
                              //         }
                              //         let udata = { 'first_name': u_fname, 'user_id': user_id, 'restaurant_id': restaurant_id, 'branch_id': 'All', 'role_id': currentUser.role_id, 'single_branch': branch, 'last_name': currentUser.last_name, 'email': currentUser.email, 'time_zone': timezone, 'campaign_id': currentUser.campaign_id, 'quick_reply_id': currentUser.quick_reply_id, "user_locale": currentUser.user_locale };
                              //         //console.log(udata);
                              //         localStorage.setItem('currentUser', JSON.stringify(udata));
                              //         localStorage.setItem('message', this.lang_value.wz_register_success);
                              //         let userdata = { 'user_id': user_id, 'page_id': page_id, 'restaurant_id': restaurant_id, 'event': 'subscribed', 'date_time': date_time };
                              //         this.userService.saveSubUnsubLog(this.backendUrl, JSON.stringify(userdata))
                              //           .subscribe(data => {
                              //               console.log(data);
                              //               $('#itag').hide();
                              //               this.router.navigate(['profiles']);
                              //               //location.reload();
                              //             },
                              //             error => {
                              //               this.alertService.error(JSON.stringify(error));
                              //             });
  
                              //       },
  
                              //       error => {
                              //         this.alertService.error(JSON.stringify(error));
                              //       });
  
                              // }
                              // else {
                                let country_id=this.countryIds.filter(element => {
                                  if(element.country.toLowerCase() == country){
                                    return element
                                  }
                               
                                }) 
                                
                              let json_data_double = {
                                restaurant_name: res_name,
                                created_at: date_time,
                                updated_at: date_time,
                                user_id: user_id,
                                page_id: page_id,
                                page_token: access_token,
                                single_branch: branch,
                                status: 0,
                                subscribed_status: 1,
                                bot_language: chat_lang,
                                webview_wl_status: 1,
                                time_zone: this.helper.timezoneValue(timezone),
                                currency: currency,
                                country: country,
                                country_id:country_id[0].id,
                                calling_code: calling_code,
                                owner_id:partner_id,
                                restaurant_setting:restaurant_setting,
                                ...payload3
                              };
                              console.log(json_data_double);
  
                              this.userService.saveWizardData(this.backendUrl, JSON.stringify(json_data_double))
                                .subscribe(data => {
                                    console.log(data);
                                    if(data.success && data.success.includes('already exist')){
                                      $('#error').html(this.lang_value.rest_already_exist);
                                      $('#error').show();
                                      $('#itag').hide();
                                      let that=this;
                                      setTimeout(function() {
                                        $('#error').hide();
                                        window.location.reload();
                                      }, 3000);
                                      
                                    }else{
                                      let restaurant_id = data.id;
                                      if (restaurant_id) {
                                        let mailData = {
                                          'first_name': currentUser.first_name,
                                          'last_name': currentUser.last_name,
                                          'email': currentUser.email,
                                          "restaurant_name":res_name,
                                          "country":country,
                                          'stage': 'Restaurant_added'
                                        };
                                        this.userService.send_mail(this.backendUrl, JSON.stringify({ 'data': mailData }))
                                          .subscribe(data => {
                                              console.log(data);
                                            },
                                            error => {
                                              // this.alertService.error(JSON.stringify(error));
                                            });
                                      }
                                      let udata = { 'first_name': u_fname, 'user_id': user_id, 'restaurant_id': restaurant_id, 'branch_id': 'All', 'role_id':  this.billingRole, 'single_branch': branch, 'last_name': currentUser.last_name, 'email': currentUser.email, 'time_zone': timezone, 'campaign_id': currentUser.campaign_id, 'user_management_roleId':currentUser.user_management_roleId, 'quick_reply_id': currentUser.quick_reply_id, "user_locale": currentUser.user_locale, "country":this.country,'bot_language':chat_lang };
                                      //console.log(udata);
                                      localStorage.setItem('currentUser', JSON.stringify(udata));
                                      // localStorage.setItem('message', this.lang_value.wz_register_success);
                                      let userdata = { 'user_id': user_id, 'page_id': page_id, 'restaurant_id': restaurant_id, 'event': 'subscribed', 'date_time': date_time };
                                      this.userService.saveSubUnsubLog(this.backendUrl, JSON.stringify(userdata))
                                        .subscribe(data => {
                                            console.log(data);
                                            $('#itag').hide();
  
                                            console.log("innnnnnnnnnnnnnnnnnnnnn create ",this.partnerId)
                                            // if(this.partnerId == 'd9e20344-0afc-4aa9-adce-615f4ebc6181'){
                                            //   this.router.navigate(['payment/plans']);
                                            // }else{
                                              this.router.navigate(['/profiles']);
                                            // }
                                           
                                            //location.reload(); 
                                          },
                                          error => {
                                            this.alertService.error(JSON.stringify(error));
                                          });
                                      // call sp_copy_bot(userid,restaurant_id,restaurant_name, timezone, currency,country);
                                    }
                                  },
  
                                  error => {
                                    this.alertService.error(JSON.stringify(error));
                                  });
  
                              // }
                            });
                        }else{
                          let country_id=this.countryIds.filter(element => {
                            if(element.country.toLowerCase() == country){
                              return element
                            }
                         
                          }) 
                        let json_data_double = {
                          restaurant_name: res_name,
                          created_at: date_time,
                          updated_at: date_time,
                          user_id: user_id,
                          page_id: null,
                          page_token:null,
                          single_branch: branch,
                          status: 0,
                          subscribed_status: 0,
                          bot_language: chat_lang,
                          webview_wl_status: 1,
                          time_zone: this.helper.timezoneValue(timezone),
                          currency: currency,
                          country: country,
                          country_id:country_id[0].id,
                          calling_code: calling_code,
                          owner_id:partner_id,
                          restaurant_setting:restaurant_setting,
                          ...payload3
                        };
                        console.log(json_data_double);

                        this.userService.saveWizardData(this.backendUrl, JSON.stringify(json_data_double))
                          .subscribe(data => {
                              console.log(data);
                              if(data.success && data.success.includes('already exist')){
                                $('#error').html(this.lang_value.rest_already_exist);
                                $('#error').show();
                                $('#itag').hide();
                                let that=this;
                                setTimeout(function() {
                                  $('#error').hide();
                                 window.location.reload();
                                }, 3000);
                                
                                  
                              }else{
                                let restaurant_id = data.id;
                                if (restaurant_id) {
                                  let mailData = {
                                    'first_name': currentUser.first_name,
                                    'last_name': currentUser.last_name,
                                    'email': currentUser.email,
                                    "restaurant_name":res_name,
                                    "country":country,
                                    'stage': 'Restaurant_added'
                                  };
                                  this.userService.send_mail(this.backendUrl, JSON.stringify({ 'data': mailData }))
                                    .subscribe(data => {
                                        console.log(data);
                                      },
                                      error => {
                                        // this.alertService.error(JSON.stringify(error));
                                      });
                                }
                                let udata = { 'first_name': u_fname, 'user_id': user_id, 'restaurant_id': restaurant_id, 'branch_id': 'All', 'role_id':  this.billingRole, 'single_branch': branch, 'last_name': currentUser.last_name, 'email': currentUser.email, 'time_zone': timezone, 'campaign_id': currentUser.campaign_id,  'user_management_roleId':currentUser.user_management_roleId, 'quick_reply_id': currentUser.quick_reply_id, "user_locale": currentUser.user_locale, "country":this.country,'bot_language':chat_lang };
                                //console.log(udata);
                                localStorage.setItem('currentUser', JSON.stringify(udata));
                                // localStorage.setItem('message', this.lang_value.wz_register_success);
                                let userdata = { 'user_id': user_id, 'page_id': page_id, 'restaurant_id': restaurant_id, 'event': 'subscribed', 'date_time': date_time };
                                this.userService.saveSubUnsubLog(this.backendUrl, JSON.stringify(userdata))
                                  .subscribe(data => {
                                      console.log(data);
                                      $('#itag').hide();
                                      console.log("innnnnnnnnnnnnnnnnnnnnn create ",this.partnerId)
                                      // if(this.partnerId == 'd9e20344-0afc-4aa9-adce-615f4ebc6181'){
                                      //   this.router.navigate(['payment/plans']);
                                      // }else{
                                        this.router.navigate(['/profiles']);
                                      // }
                                      
                                    
                                      //location.reload(); 
                                    },
                                    error => {
                                      this.alertService.error(JSON.stringify(error));
                                    });
                                // call sp_copy_bot(userid,restaurant_id,restaurant_name, timezone, currency,country);
                              }
                            },

                            error => {
                              this.alertService.error(JSON.stringify(error));
                            });
                        }
                      }
                    });
                  //end of whitlisting domains
                }
              },
              error => {
                $('#error').html(this.lang_value.wz_login_again);
                $('#error').show();
                setTimeout(function() {
                  $('#error').hide();
                }, 3000);

              });
        }

      })

  }

}

function toLowerCase(country: any) {
  throw new Error('Function not implemented.');
}
function toUpperCase(country: any) {
  throw new Error('Function not implemented.');
}




// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/wizard/wizard.component.ts